import { mdiImageArea, mdiChevronLeft, mdiChevronRight, mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import { Button, Drawer, Flex, Image, Modal } from "antd";
import { CarouselRef } from "antd/es/carousel";
import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";

// `v3` is the mobile V3 hero: "All Photos (N)" button opening a bottom sheet with every photo,
// instead of going straight into the full-screen viewer.
const ItineraryImages = ({ images, cover, isMobile, isV3}: { images: string[]; cover?: string; isMobile: boolean, isV3: boolean }) => {
  const [visible, setVisible] = useState(false);
  const [sheetOpen, setSheetOpen] = useState(false);
  const [current, setCurrent] = useState(0);
  const thumbnailsRef = useRef<HTMLDivElement>(null);
  const carouselRef = useRef<CarouselRef>(null);

  const settings = {
    dots: true,
    arrows: false,
    slidesToShow: 1,
    pauseOnHover:false,
    speed: 500,
    infinite: images.length > 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
  };  
  useEffect(() => {
    const container = thumbnailsRef.current;
  
    if (!container) return;
  
    const activeThumbnail = container.querySelector(
      ".gallery-thumbnail.active"
    ) as HTMLElement | null;
  
    if (activeThumbnail) {
      activeThumbnail.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [current]);


  const openGallery = (index = 0) => {
    setVisible(true);
    setTimeout(() => {
      carouselRef.current?.goTo(index, false);
    }, 0);
  };

  const openPreviewAt = (index: number) => {
    setCurrent(index);
    setVisible(true);
  };

  return (
    <div className="itinerary-images">
      <Slider {...settings}>
        {
          images.map((src, i) => (
            <div className="itinerary-image-slide" key={i}>
              <div
                className="itinerary-image-slide__background"
                style={{ backgroundImage: `url(${src})` }}
              />
              <Image
                key={i}
                alt="Itinerary images"
                className="itinerary-image-slide__image"
                preview={false}
                src={src}
                fallback="data:image/png;base64,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"
              />
            </div>
          ))
        }
      </Slider>

      {images.length > 1 && (
        <Button
          className="show-all-photos-button"
          onClick={() => ((isV3 && isMobile) ? setSheetOpen(true) : setVisible(true))}
          icon={ isMobile ? <Icon path={mdiImageArea} size={1} /> : <img className="icon-flipped" src="/iceholidays-assets/images/v3/image-icon.svg" alt="" aria-hidden="true" /> }
        >
          <span className="show-all-photos-button-label-mobile">{isV3 ? `All Photos (${images.length})` : "All"}</span>
          <span className="show-all-photos-button-label-desktop">{isMobile ? 'Show All Photos' : `View All Photos (${images.length})`}</span>
        </Button>
      )}

      {(!isV3 || isMobile) ? 
        <div style={{ display: "none" }}>
          <Image.PreviewGroup
            items={images}
            preview={{
              visible,
              onVisibleChange: (v) => setVisible(v),
              toolbarRender: () => null,
              rootClassName: isV3 ? 'v3 itinerary-image-preview' : 'itinerary-image-preview',
              ...(isV3 ? { current, onChange: (c: number) => setCurrent(c) } : {})
            }}
          />
        </div>
        : <>
          <Modal
            open={visible}
            onCancel={() => setVisible(false)}
            footer={null}
            closable={false}
            centered
            width={1200}
            className="itinerary-gallery-modal"
            wrapClassName="v3"
            destroyOnClose
          >
            <div className="gallery-header">
              <span className="gallery-title">
                All Photos ({images.length})
              </span>

              <button
                type="button"
                className="gallery-close"
                onClick={() => setVisible(false)}
              >
                <Icon path={mdiClose} />
              </button>
            </div>

            <div className="gallery-main">
              {/* Blurred background */}
              <img className="gallery-main-bg" src={images[current]} alt=""/>

              {/* Actual image */}
              <img
                src={images[current]}
                alt=""
                className="gallery-main-image"
              />

              {images.length > 1 && (
                <>
                  <button
                    type="button"
                    className="gallery-arrow gallery-arrow--left"
                    onClick={() =>
                      setCurrent(prev =>
                        prev === 0 ? images.length - 1 : prev - 1
                      )
                    }
                  >
                    <Icon path={mdiChevronLeft} />
                  </button>

                  <button
                    type="button"
                    className="gallery-arrow gallery-arrow--right"
                    onClick={() =>
                      setCurrent(prev =>
                        prev === images.length - 1 ? 0 : prev + 1
                      )
                    }
                  >
                    <Icon path={mdiChevronRight} />
                  </button>
                </>
              )}

              <div className="gallery-counter">
                {current + 1}/{images.length}
              </div>
            </div>

            <div ref={thumbnailsRef} className="gallery-thumbnails">
              {images.map((image, index) => (
                <button
                  key={index}
                  type="button"
                  className={`gallery-thumbnail ${
                    current === index ? "active" : ""
                  }`}
                  onClick={() => setCurrent(index)}
                >
                  <img src={image} alt="" />
                </button>
              ))}
            </div>
          </Modal>
        </>
      }

      {isV3 && (
        <Drawer
          title={`All Photos (${images.length})`}
          placement="bottom"
          height="calc(100% - 55px)"
          open={sheetOpen}
          onClose={() => setSheetOpen(false)}
          rootClassName="v3-photos-sheet"
        >
          <div className="v3-photos-sheet_list">
            {images.map((src, i) => (
              <button
                key={i}
                type="button"
                className="v3-photos-sheet_item"
                aria-label={`View photo ${i + 1} of ${images.length}`}
                onClick={() => openPreviewAt(i)}
              >
                <img src={src} alt="" loading="lazy" />
              </button>
            ))}
          </div>
        </Drawer>
      )}
    </div>
  );
};

export default ItineraryImages;